/**
 * @fileoverview gRPC-Web generated client stub for contact_sales
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/product_trial.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.contact_sales = require('./product_trial_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contact_sales.ProductTrialServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contact_sales.ProductTrialServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contact_sales.ProductTrialRequest,
 *   !proto.contact_sales.ProductTrialResponse>}
 */
const methodDescriptor_ProductTrialService_ProductTrial = new grpc.web.MethodDescriptor(
  '/contact_sales.ProductTrialService/ProductTrial',
  grpc.web.MethodType.UNARY,
  proto.contact_sales.ProductTrialRequest,
  proto.contact_sales.ProductTrialResponse,
  /**
   * @param {!proto.contact_sales.ProductTrialRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contact_sales.ProductTrialResponse.deserializeBinary
);


/**
 * @param {!proto.contact_sales.ProductTrialRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contact_sales.ProductTrialResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contact_sales.ProductTrialResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contact_sales.ProductTrialServiceClient.prototype.productTrial =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contact_sales.ProductTrialService/ProductTrial',
      request,
      metadata || {},
      methodDescriptor_ProductTrialService_ProductTrial,
      callback);
};


/**
 * @param {!proto.contact_sales.ProductTrialRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contact_sales.ProductTrialResponse>}
 *     Promise that resolves to the response
 */
proto.contact_sales.ProductTrialServicePromiseClient.prototype.productTrial =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contact_sales.ProductTrialService/ProductTrial',
      request,
      metadata || {},
      methodDescriptor_ProductTrialService_ProductTrial);
};


module.exports = proto.contact_sales;

